const getCurrencyMaxDecimals = (currency: Currency) => {
  return Intl.NumberFormat(undefined, { style: 'currency', currency }).resolvedOptions().maximumFractionDigits ?? 2;
};

export default getCurrencyMaxDecimals;
